import { fetchApi } from '@inmagik/react-crud'
import dayjs from 'dayjs'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import { Button, Card, CardBody } from 'react-bootstrap'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import { useAuth } from '../../auth'
import ModalForm from '../../components/ModalForm'
import { API_URL } from '../../constants'
import { transformErrorForForm, useIsCliente } from '../../utils/utils'
import FormCambioPassword from './FormCambioPassword'

const initialValues = {
  old_password: '',
  password: '',
  confirm_password: '',
}

const schema = yup.object().shape({
  old_password: yup.string().required().label('Vecchia password'),
  password: yup.string().required().label('Password'),
  confirm_password: yup
    .string()
    .required()
    .oneOf([yup.ref('password')], 'Le password non corrispondono')
    .label('Conferma password'),
})

export default function Profilo() {
  const { user, tokens, performLogout } = useAuth()
  const [modalStateCambiapassword, modalActionsCambiapassword] = useModalTrigger()

  const isCliente = useIsCliente()
  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h1 className="title">Profilo</h1>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-6">
          <Card>
            <CardBody>
              <div className="row">
                <div className="col-md-6">
                  <h5 className="label-m text-body-secondary">Nome e cognome</h5>
                  <p>{user?.full_name}</p>
                </div>
                <div className="col-md-6">
                  <h5 className="label-m text-body-secondary">Email</h5>
                  <p>{user?.email}</p>
                </div>
                <div className="col-md-6">
                  <h5 className="label-m text-body-secondary">Ruolo</h5>
                  <p className="text-capitalize">{user?.role}</p>
                </div>
                <div className="col-md-6">
                  <h5 className="label-m text-body-secondary">Password impostata</h5>
                  <p>********</p>
                </div>
                {isCliente && (
                  <div className="col-md-6">
                    <h5 className="label-m text-body-secondary">Data scadenza</h5>
                    <p className="text-capitalize">
                      {user?.expiration_date ? dayjs(user.expiration_date).format('DD/MM/YYYY') : 'N/A'}
                    </p>
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-between align-items-center">
                <Button
                  variant="secondary"
                  className="text-white"
                  onClick={() => {
                    performLogout()
                  }}
                >
                  Logout
                </Button>

                <Button
                  variant="outline-secondary"
                  className="bg-secondary-light"
                  onClick={() => {
                    modalActionsCambiapassword.open()
                  }}
                >
                  Cambia password
                </Button>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
      {modalStateCambiapassword.isOpen && (
        <ModalForm
          title="Cambia password"
          initialValues={initialValues}
          isOpen={modalStateCambiapassword.isOpen}
          save={async (values, actions) => {
            fetchApi(API_URL + '/utenti/change-password/', {
              method: 'PUT',
              body: JSON.stringify(values),
              headers: {
                Authorization: `Bearer ${tokens?.access}`,
                'Content-Type': 'application/json',
              },
            })
              .then(() => {
                modalActionsCambiapassword.close()
                toast.success('Password cambiata con successo', {
                  position: 'bottom-right',
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                })
              })
              .catch((e) => {
                actions.setErrors(transformErrorForForm(e))
              })
          }}
          schema={schema}
          toggle={modalActionsCambiapassword.toggle}
        >
          <FormCambioPassword />
        </ModalForm>
      )}
    </div>
  )
}
